import React from 'react';

export default function SheildExpiredIcon() {
    return (
        <svg
            width="104"
            height="128"
            viewBox="0 0 104 128"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_1014_34393)">
                <path
                    d="M47.6376 124.168C49.0213 124.975 49.7131 125.379 50.6895 125.588C51.4472 125.751 52.5528 125.751 53.3105 125.588C54.2869 125.379 54.9787 124.975 56.3624 124.168C68.5378 117.065 102 94.7528 102 64.075V34.185C102 29.1881 102 26.6896 101.183 24.5419C100.461 22.6446 99.2876 20.9517 97.7646 19.6096C96.0407 18.0902 93.7013 17.213 89.0225 15.4584L55.5112 2.89171C54.2119 2.40445 53.5622 2.16083 52.8938 2.06425C52.301 1.97858 51.699 1.97858 51.1061 2.06425C50.4378 2.16083 49.7881 2.40445 48.4888 2.89171L14.9775 15.4584C10.2987 17.213 7.95935 18.0902 6.23537 19.6096C4.71239 20.9517 3.53922 22.6446 2.81725 24.5419C2 26.6896 2 29.1881 2 34.185V64.075C2 94.7528 35.4623 117.065 47.6376 124.168Z"
                    stroke="#0080FF"
                    stroke-width="4"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M52 51.5395V61.9605L58.4706 65.8684M52 39.8158C39.8497 39.8158 30 49.7303 30 61.9605C30 74.1907 39.8497 84.1053 52 84.1053C64.1503 84.1053 74 74.1907 74 61.9605C74 49.7303 64.1503 39.8158 52 39.8158ZM52 39.8158V32M46.8235 32H57.1765M73.5574 41.3582L69.675 37.4503L71.6162 39.4043M30.4426 41.3582L34.325 37.4503L32.3838 39.4043"
                    stroke="#0080FF"
                    stroke-width="4"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </g>
            <defs>
                <clipPath id="clip0_1014_34393">
                    <rect
                        width="104"
                        height="128"
                        fill="white"
                    />
                </clipPath>
            </defs>
        </svg>
    );
}
